import { AgentSerpStoreParamsSearchInputAdapter } from 'common/module/agent-serp/store/params/search-input-adapter';

export function AgentSerpStoreParamsSearchInputAdapterFactory(): AgentSerpStoreParamsSearchInputAdapter {
  return new AgentSerpStoreParamsSearchInputAdapter();
}
